import { Collapse } from 'antd';
import styled from 'styled-components';

export const CollapseQueryDisplay = styled(Collapse)`
    border-top: none;
    background-color: #ffffff;
    border-radius: 0 0 6px 6px
`;